import { render, staticRenderFns } from "./mendianSelect.vue?vue&type=template&id=1fa8e52b&scoped=true"
import script from "./mendianSelect.vue?vue&type=script&lang=js"
export * from "./mendianSelect.vue?vue&type=script&lang=js"
import style0 from "./mendianSelect.vue?vue&type=style&index=0&id=1fa8e52b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8e52b",
  null
  
)

export default component.exports